module.exports = __webpack_public_path__ + "static/media/5-c2_old.beb3a000.jpg";